<i18n src="@/locales/models/harvested_batch.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/exported_batch.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/package.yml" lang="yaml"></i18n>

<template>
  <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
    <div class="sm:col-span-3">
      <label class="label-form">
        {{ $t("model.package.producer") }}
      </label>
      <div class="mt-1">
        <select-form v-if="producers.length > 0" :options="producers" label="label" v-model="pkg.producer_id"
          :is_invalid="isInvalidSelect('producer')" />
      </div>
    </div>
    <div class="sm:col-span-3">
      <label class="label-form">
        {{ $t("model.harvested_batch.crop_field") }}
      </label>
      <div class="mt-1" v-if="crop_fields.length > 1">
        <select-form :options="crop_fields" v-model="pkg.exported_batch.crop_field_id"
          :is_invalid="isInvalidSelect('crop_field')" />
      </div>
      <dd class="content-data" v-else-if="crop_fields.length == 1">
        {{ crop_fields[0].name }}
      </dd>
      <div class="space-x-2 mt-2">
        <template v-for="(certification, index) in crop_field_certifications" :key="index">
          <danger-badge v-if="availableCertification(certification)" :label="certification.certification.name" />
          <success-badge v-else :label="certification.certification.name" />
        </template>
      </div>
    </div>
    <div class="sm:col-span-3">
      <label class="label-form">
        {{ $t("model.package.quantity") }}
      </label>
      <div class="mt-1">
        <input type="number" v-model.trim="pkg.quantity" :class="['input-text', isInvalid('quantity')]" />
      </div>
    </div>
    <div class="sm:col-span-3" v-if="exporter_process_crop_categories.length > 1">
      <label class="label-form">
        {{ $t("model.package.exporter_process_crop_category") }}
      </label>
      <div class="mt-1">
        <select-form :options="exporter_process_crop_categories" v-model="pkg.exporter_process_crop_category_id"
          :is_invalid="isInvalidSelect('exporter_process_crop_category')" />
      </div>
    </div>
    <div class="sm:col-span-3" v-if="exporter_process_crop_varieties.length > 1">
      <label class="label-form">
        {{ $t("model.package.exporter_process_crop_variety") }}
      </label>
      <div class="mt-1">
        <select-form :options="exporter_process_crop_varieties" v-model="pkg.exporter_process_crop_variety_id"
          :is_invalid="isInvalidSelect('exporter_process_crop_variety')" />
      </div>
    </div>
    <div class="sm:col-span-3" v-if="exporter_process_crop_sizes.length > 1">
      <label class="label-form">
        {{ $t("model.package.exporter_process_crop_size") }}
      </label>
      <div class="mt-1">
        <select-form :options="exporter_process_crop_sizes" v-model="pkg.exporter_process_crop_size_id"
          :is_invalid="isInvalidSelect('exporter_process_crop_size')" />
      </div>
    </div>
    <div class="sm:col-span-3" v-if="exporter_process_crop_packages.length > 1">
      <label class="label-form">
        {{ $t("model.package.exporter_process_crop_package") }}
      </label>
      <div class="mt-1">
        <select-form :options="exporter_process_crop_packages" v-model="pkg.exporter_process_crop_package_id"
          :is_invalid="isInvalidSelect('exporter_process_crop_package')" />
      </div>
    </div>
    <template v-if="pkg.exporter_process_crop_package_id && !pkg.exporter_process_brand_id">
      <div class="sm:col-span-3" v-if="exporter_process_brands.length > 1">
        <label class="label-form">
          {{ $t("model.package.exporter_process_brand") }}
        </label>
        <div class="mt-1">
          <select-form
            :options="exporter_process_brands"
            v-model="pkg.exporter_process_brand_id"
            :is_invalid="isInvalidSelect('exporter_process_brand')"
          />
        </div>
      </div>
    </template>
    <div class="sm:col-span-3" v-if="packing_lines.length > 1">
      <label class="label-form">
        {{ $t("model.package.packing_line") }}
      </label>
      <div class="mt-1">
        <select-form :options="packing_lines" v-model="pkg.packing_line_id"
          :is_invalid="isInvalidSelect('packing_line')" />
      </div>
    </div>
    <div class="sm:col-span-3" v-if="packing_house_processes.length > 1">
      <label class="label-form">
        {{ $t("model.exported_batch.packing_house_process") }}
      </label>
      <div class="mt-1">
        <select-form :options="packing_house_processes" v-model="pkg.exported_batch.packing_house_process_id"
          :is_invalid="isInvalidSelect('exported_batch.packing_house_process')" />
      </div>
    </div>
  </div>
</template>

<script>
import RequesterQuery from "@/views/organization/requesters/process/packing/queries_to_package.js";

export default {
  name: "PackageNew",
  components: {},
  data() {
    return {
      pkg: this.modelValue || {},
      crop_field_certifications: [],
      crop_fields: []
    };
  },
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
    organization_id: {
      required: true,
    },
    harvested_batch_id: {
      required: true,
    },
    producers: {
      type: Array,
      required: true,
    },
    exporter_process_crop_packages: {
      type: Array,
      required: true,
    },
    exporter_process_crop_categories: {
      type: Array,
      required: true,
    },
    exporter_process_crop_varieties: {
      type: Array,
      required: true,
    },
    exporter_process_crop_sizes: {
      type: Array,
      required: true,
    },
    exporter_process_brands: {
      type: Array,
      required: true,
    },
    harvested_batch: {
      type: Object,
      required: true
    },
    packing_lines: {
      type: Array,
      required: true,
    },
    packing_house_processes: {
      type: Array,
      required: true,
    }
  },
  methods: {
    fetchCropFields: async function () {
      const response = await RequesterQuery.fetchCropFields(
        this.organization_id,
        this.harvested_batch_id,
        this.pkg.producer_id,
      );
      this.crop_fields = response.data;
      if (this.crop_fields.length == 1) {
        this.pkg.exported_batch.crop_field_id = this.crop_fields[0].id;
      } else if (this.pkg.producer_id == this.harvested_batch.producer_id) {
        this.pkg.exported_batch.crop_field_id = this.harvested_batch.crop_field_id;
      }
    },
    fetchOrganizationCropField: async function () {
      const response = await RequesterQuery.fetchOrganizationCropField(
        this.organization_id,
        this.pkg.exported_batch.crop_field_id
      );
      if (!this.pkg.packing_line_id)
        this.pkg.packing_line_id = response.data.packing_line_id;
    },
    fetchCropFieldCertifications: async function () {
      const response = await RequesterQuery.fetchCropFieldCertifications(
        this.organization_id,
        this.pkg.exported_batch.crop_field_id
      );
      this.crop_field_certifications = response.data.sort(
        (a, b) =>
          this.availableCertification(a) - this.availableCertification(b)
      );
    },
    availableCertification: function (certification) {
      return (
        this.daysUntilExpirationDate(certification.expiration_date) < 0 ||
        certification.suspended
      );
    },
  },
  watch: {
    "pkg.producer_id": {
      handler: function (new_value) {
        if (new_value) {
          this.pkg.exported_batch.crop_field_id = null;
          this.fetchCropFields();
        }
      },
      immediate: true
    },
    "pkg.exported_batch.crop_field_id": function (new_value) {
      this.pkg.packing_line_id = null;
      if (new_value) {
        this.fetchOrganizationCropField();
        this.fetchCropFieldCertifications();
      }
    },
    "pkg.exporter_process_crop_package_id": function (
      exporter_process_crop_package_id
    ) {
      if (!exporter_process_crop_package_id) {
        this.pkg.exporter_process_brand_id = null;
        return;
      }

      let exporter_process_corp_package =
        this.exporter_process_crop_packages.find(
          (exp_process_crop_package) =>
            exp_process_crop_package.id == exporter_process_crop_package_id
        );

      if (exporter_process_corp_package) {
        this.pkg.exporter_process_brand_id =
          exporter_process_corp_package?.exporter_process_brand_id;
      }
    },
  }
};
</script>
